$.material.init();
document.addEventListener("DOMContentLoaded", function () {
  const aside = document.getElementById("aside");
  
  function handleMouseLeave() {
    const openCollapses = document.querySelectorAll(".collapse.show");
    aside.classList.add("reduced");
    openCollapses.forEach((collapse) => {
      const bsCollapse = new bootstrap.Collapse(collapse, {
        toggle: false,
      });
      bsCollapse.hide();
    });
  }
  
  function handleMouseEnter() {
    aside.classList.remove("reduced");
  }
  
  // Función principal para gestionar eventos en función del tamaño de la pantalla
  function closeCollapseOnMouseLeave() {
    if (window.matchMedia("(min-width: 760px) and (max-width: 1379px)").matches) {
      aside.addEventListener("mouseleave", handleMouseLeave);
      aside.addEventListener("mouseenter", handleMouseEnter);
    } else {
      console.log("holi");
      aside.removeEventListener("mouseleave", handleMouseLeave);
      aside.removeEventListener("mouseenter", handleMouseEnter);
    }
  }

    document.getElementById("btn-menu").addEventListener("click",() => {
      document.body.classList.toggle('aside-open')
      document.getElementById('aside').classList.toggle('reduced')
      document.getElementById('btn-menu').classList.toggle('hide')
    })
    document.querySelector(".backdrop").addEventListener("click",() => {
      document.body.classList.remove('aside-open')
      document.getElementById('aside').classList.add('reduced')
      document.getElementById('btn-menu').classList.add('hide')
    })
  closeCollapseOnMouseLeave();
 

  const collapseElements = document.querySelectorAll(".collapse");

  collapseElements.forEach(collapse => {
    const button = document.querySelector(`[data-bs-target="#${collapse.id}"]`);

    button.addEventListener("click", function () {
      // Cierra todos los colapsos excepto el actual
      collapseElements.forEach(otherCollapse => {
        if (otherCollapse !== collapse) {
          new bootstrap.Collapse(otherCollapse, { toggle: false }).hide();
        }
      });
    });
  });
  if(document.querySelector('.swiper-home')) { 
    var swiper = new Swiper(".swiper-home", {
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      loop: true,
      spaceBetween: 30,
      effect: "fade",
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true,
      },
    });
  }
  if(document.querySelectorAll('.video-js')) {
    document.querySelectorAll('.video-js').forEach(video => {
      new window.Vlitejs(video, {
        options: {
          controls: true,
          autoplay: false,
          playPause: true,
          progressBar: true,
          time: true,
          volume: true,
          fullscreen: true,
          poster: "https://yoriiis.github.io/cdn/static/vlitejs/demo-poster.jpg",
          bigPlay: true,
          playsinline: true,
          loop: false,
          muted: false,
          autoHide: true,
        },
      });
    }
    )
  }


});
window.addEventListener("resize", () => {
  closeCollapseOnMouseLeave();
  if(window.matchMedia("(min-width: 760px)").matches) { 
    if( document.body.classList.contains('aside-open')) {
      document.body.classList.remove('aside-open')
      document.getElementById('btn-menu').classList.add('hide')
      document.getElementById('aside').classList.add('reduced')
    }
  }
});